<core-progress-bar></core-progress-bar>
<empty-layout *ngIf="layout === 'empty'"></empty-layout>
<simple-layout *ngIf="layout === 'simple'"></simple-layout>
